
import { Options, Vue } from "vue-class-component";
import Alert from "./Alert.vue";

@Options({
  components: {
    Alert,
  },
})
export default class GameExplanation extends Vue {
  open(scrollRef?: string) {
    (this.$refs.alert as Alert).showModal = true;

    if (scrollRef !== undefined) {
      requestAnimationFrame(() =>
        requestAnimationFrame(() =>
          requestAnimationFrame(() =>
            document.getElementById(scrollRef)?.scrollIntoView()
          )
        )
      );
    }
  }
}
